import React, { useEffect } from 'react';
import styles from './TextWithTooltip.module.scss';

interface Props {
  text: string;
}

const TextWithTooltip = (props: Props) => {
  const { text } = props;

  return (
    <div className={styles.container}>
      <p className={styles.label}>{text}</p>
      <p className={styles.tooltip}>{text}</p>
    </div>
  );
};

export default TextWithTooltip;
